<template>
    <div id="app">
        <div id="pageLoading">
            <!-- <loading></loading> -->
        </div>

        <keep-alive>
            <router-view v-if="$route.meta.keepAlive"></router-view>
        </keep-alive>
        <!-- 不需要被缓存的路由入口 -->
        <router-view v-if="!$route.meta.keepAlive"></router-view>
    </div>
</template>
<script>
export default {
    name: "App",
    data() {
        return {};
    },
    updated() {
        document.getElementById("pageLoading").style.display = "flex";
        setTimeout(() => {
            document.getElementById("pageLoading").style.display = "none";
        }, 500);
    }
};
</script>
<style lang="less">
#app {
    font-family: "Avenir", Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    // margin-top: 60px;
    // background: #f8f8f8;
    min-height: 100vh;
}
input {
    box-shadow: 0 0 0px 1000px white inset;
}
textarea{
    background: #ffffff;
}

.no-more {
    width: 100%;
    img {
        width: 50%;
        // height: 50%;
        margin-top: 100px;
    }
    > div {
        font-size: 16px;
        color: #cccccc;
        padding: 30px 0;
    }
}
.bo {
    width: 100%;
    background: #ffffff;
    padding-bottom: 50px;
    .van-pagination {
        width: 70%;
        margin: 0 auto;
    }
}
</style>
